import { render } from "./NotesSection.vue?vue&type=template&id=48f87a6a&scoped=true"
import script from "./NotesSection.vue?vue&type=script&lang=js"
export * from "./NotesSection.vue?vue&type=script&lang=js"

import "./NotesSection.vue?vue&type=style&index=0&id=48f87a6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f87a6a"]])

export default __exports__